import { API_BASE, buildHeaders, fetchWithAuth } from "./api";
import { auth } from "../api/auth";

/**
 * Нужно ли отправлять пользователя на шаг установки PWA (шаг 3/3):
 * true  — если таймзона уже выбрана и PWA ещё НЕ установлен
 * false — иначе
 */
export async function shouldGoToInstallPwa(_client_id: string) {
  const user = await getCurrentUser();
  if (!user) return false;

  const hasTimezone = Boolean(user.timezone);
  const installed = user.pwa_installed === true;

  return hasTimezone && !installed;
}

export async function getCurrentUser() {
  const res = await fetchWithAuth(`${API_BASE}/auth/bff/me`, {
    headers: buildHeaders(false),
  });
  if (!res.ok) return null;
  const data = await res.json();
  // Задание 3E: точка восстановления CSRF-токена — если localStorage
  // очистился, а сессия ещё жива, /auth/bff/me отдаёт csrf заново.
  if (data?.csrf) auth.setCsrfToken(data.csrf);
  return data?.ok ? (data.user ?? null) : null;
}
